export const articles = [
  {
    id: 1,
    title: 'CLANNAD 全路线攻略指南 — 从校园篇到After Story完美通关',
    slug: 'clannad-full-guide',
    excerpt: '详细解析CLANNAD全部路线进入条件与关键选项，包含学园篇8条路线与After Story完整攻略，助你收集全部光玉解锁真结局。',
    content: `
      <h2>前言</h2>
      <p>CLANNAD作为Key社最具代表性的作品，以其庞大的剧本量和丰富的情感体验著称。游戏分为「学园篇」和「After Story」两大部分，共有8条女主角路线，每条路线都隐藏着收集"光玉"的关键事件。本攻略将带你一步步完成全路线通关。</p>
      
      <h2>系统说明</h2>
      <p>CLANNAD的核心收集要素是「光玉」。每当完成一条女主角路线，根据结局的完整度，你可能会获得一颗光玉。收集足够数量的光玉是进入After Story和真结局的条件。</p>
      <p>游戏中的选项会影响好感度、剧情分支和最终结局。建议按照以下顺序攻略以获得最佳体验。</p>
      
      <h2>学园篇攻略顺序</h2>
      
      <h3>一、古河渚路线</h3>
      <p>渚是CLANNAD的第一女主角。建议将渚路线放在最后攻略，因为完成她的路线后才能自然衔接到After Story。以下是关键选项：</p>
      <ul>
        <li>4月14日：在教室遇到渚时，选择「打招呼」</li>
        <li>4月15日：选择「去中庭」寻找渚</li>
        <li>4月16日：选择「帮她」来帮助渚重建演剧部</li>
        <li>4月17日-20日：持续选择与渚相关的选项，加深羁绊</li>
      </ul>
      
      <h3>二、藤林杏路线</h3>
      <p>杏是充满活力的傲娇角色。攻略要点在于正确处理她与妹妹椋之间的感情。</p>
      <ul>
        <li>关键：在椋表白时选择「拒绝」，否则将进入椋路线</li>
        <li>多与杏在图书馆互动，选择支持她的选项</li>
      </ul>
      
      <h3>三、一之濑琴美路线</h3>
      <p>琴美是天才少女，路线充满文学与科学气息。</p>
      <ul>
        <li>多去图书馆，触发与琴美的偶遇事件</li>
        <li>关注她的过去和父母的故事</li>
      </ul>
      
      <h3>四、坂上智代路线</h3>
      <p>智代是学生会长，路线涉及校园政治与个人成长。</p>
      <ul>
        <li>支持智代竞选学生会长</li>
        <li>帮助她处理与弟弟的关系</li>
      </ul>
      
      <h3>五、伊吹风子路线</h3>
      <p>风子路线充满奇幻色彩，是游戏中最令人难忘的篇章之一。</p>
      <ul>
        <li>接受风子赠送的木雕海星</li>
        <li>帮助风子完成她的心愿</li>
      </ul>
      
      <h3>六、宫泽有纪宁路线</h3>
      <p>有纪宁路线相对较短，但充满治愈感。</p>
      <ul>
        <li>多次前往资料室与有纪宁交流</li>
        <li>学习她的咒语书知识</li>
      </ul>
      
      <h3>七、藤林椋路线</h3>
      <p>椋是杏的双胞胎妹妹，性格温柔内向。</p>
      <ul>
        <li>在占卜室多与椋互动</li>
        <li>在杏路线中拒绝杏而接受椋即可进入</li>
      </ul>
      
      <h3>八、春原阳平路线（隐藏）</h3>
      <p>虽然是男性角色，但阳平路线提供了重要的剧情补充。</p>
      <ul>
        <li>多与阳平互动，选择搞笑的选项</li>
      </ul>
      
      <h2>After Story攻略</h2>
      <p>完成学园篇全部路线并收集足够光玉后，After Story将自动解锁。这部分讲述渚毕业后与朋也的婚后生活，是CLANNAD真正的精华所在。</p>
      <p>After Story的关键在于体验而非选项，请准备好纸巾，享受这段感人至深的旅程。</p>
      
      <h2>真结局条件</h2>
      <p>收集全部13颗光玉后，在After Story的最终章选择正确的选项，即可触发真结局「小さな手のひら」。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=CLANNAD%20visual%20novel%20screenshot%20with%20cherry%20blossom%20path%20and%20school%20building%2C%20warm%20golden%20hour%20light%2C%20emotional%20romantic%20atmosphere%2C%20anime%20game%20art%20style%2C%20soft%20pastel%20colors&width=800&height=600&seq=article-clannad-guide&orientation=landscape',
    category: '攻略合集',
    author: 'Galgame攻略组',
    date: '2024-03-15',
    tags: ['CLANNAD', 'Key社', '全路线攻略', '光玉收集'],
    readCount: 48500,
  },
  {
    id: 2,
    title: '命运石之门 所有结局达成条件与隐藏要素解析',
    slug: 'steins-gate-all-endings',
    excerpt: '详解命运石之门全部6个结局的达成条件，包括真结局、各角色结局及隐藏CG解锁方法，助你完整体验这部时间旅行科幻神作。',
    content: `
      <h2>前言</h2>
      <p>命运石之门（Steins;Gate）以其复杂的时间线系统和多结局设计著称。游戏共有6个结局，每个结局都揭示了故事的不同侧面。本攻略详细列出所有结局的达成条件。</p>
      
      <h2>结局一览</h2>
      
      <h3>1. 真结局「境界面上的命运石之门」</h3>
      <p>这是游戏的真结局，需要满足最严格的条件。核心在于在特定章节正确回复关键角色的邮件，并确保与所有角色的好感度达标。</p>
      
      <h3>2. 牧濑红莉栖结局</h3>
      <p>助手路线，关注与红莉栖的互动，在关键节点做出正确选择。</p>
      
      <h3>3. 椎名真由理结局</h3>
      <p>真由理的结局，需要在时间跳跃中选择优先保护她。</p>
      
      <h3>4. 菲利斯·喵喵结局</h3>
      <p>关注与菲利斯的邮件互动，在一系列选项中偏向她。</p>
      
      <h3>5. 漆原琉华结局</h3>
      <p>琉华的结局，涉及D-Mail相关的重要选择。</p>
      
      <h3>6. 阿万音铃羽结局</h3>
      <p>打工战士的结局，在特定章节做出选择即可进入。</p>
      
      <h2>邮件回复系统说明</h2>
      <p>命运石之门的核心系统之一是手机邮件回复。游戏中有大量需要回复关键字的邮件，回复内容直接影响好感度和剧情走向。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=SteinsGate%20visual%20novel%20screenshot%20with%20futuristic%20lab%20and%20time%20machine%2C%20dark%20atmospheric%20lighting%2C%20sci-fi%20theme%2C%20mysterious%20anime%20art%20style%2C%20cool%20blue%20tones&width=800&height=600&seq=article-steinsgate-guide&orientation=landscape',
    category: '攻略合集',
    author: 'Galgame攻略组',
    date: '2024-02-28',
    tags: ['命运石之门', '科幻', '多结局', '时间旅行'],
    readCount: 39200,
  },
  {
    id: 3,
    title: '2024年最受期待的10款Galgame新作盘点',
    slug: '2024-upcoming-galgames',
    excerpt: '盘点2024年即将发售的10款重磅Galgame新作，包括Key社新作、柚子社新作等，Galgame玩家不可错过的年度前瞻。',
    content: `
      <h2>2024年Galgame新作前瞻</h2>
      <p>2024年对于Galgame玩家来说是充满期待的一年。多款备受瞩目的作品将在今年发售，以下是本站编辑精选的10款最受期待新作。</p>
      
      <h3>1. Key社新作「anemoi」</h3>
      <p>Key社时隔多年的全新原创作品，以风为主题，讲述关于记忆与羁绊的故事。预计2024年秋季发售。</p>
      
      <h3>2. ゆずソフト新作</h3>
      <p>柚子社在「天使☆騒々 RE-BOOT!」之后的又一部力作，延续柚子社一贯的轻松恋爱喜剧风格。</p>
      
      <h3>3. TYPE-MOON相关新企划</h3>
      <p>型月社在2024年也有新动作，虽然具体内容尚未公布，但任何TYPE-MOON相关消息都值得关注。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=2024%20upcoming%20Japanese%20visual%20novel%20games%20collage%20with%20colorful%20anime%20characters%2C%20modern%20clean%20design%2C%20bright%20and%20optimistic%20atmosphere%2C%20game%20magazine%20style%20layout&width=800&height=600&seq=article-2024-preview&orientation=landscape',
    category: '业界资讯',
    author: 'Galgame资讯站',
    date: '2024-01-10',
    tags: ['新作', '2024', '业界资讯', 'Key社', '柚子社'],
    readCount: 52100,
  },
  {
    id: 4,
    title: 'Galgame汉化补丁安装教程 — 新手必看的完整指南',
    slug: 'galgame-patch-install-guide',
    excerpt: '从零开始的Galgame汉化补丁安装教程，涵盖常见补丁类型、安装步骤、常见问题排查，让新手也能轻松玩上汉化版Galgame。',
    content: `
      <h2>前言</h2>
      <p>对于不懂日语的玩家来说，汉化补丁是体验Galgame的重要桥梁。本教程将详细介绍如何正确安装各类汉化补丁。</p>
      
      <h2>补丁类型说明</h2>
      
      <h3>1. 直接覆盖型补丁</h3>
      <p>最常见的补丁类型，将补丁文件直接复制到游戏安装目录覆盖原文件即可。</p>
      
      <h3>2. 安装程序型补丁</h3>
      <p>带有独立安装程序的补丁，双击运行后按照提示选择游戏目录完成安装。</p>
      
      <h3>3. 外挂式补丁</h3>
      <p>不修改游戏原文件，通过额外程序加载汉化文本。</p>
      
      <h2>通用安装步骤</h2>
      <ol>
        <li>下载对应游戏版本的汉化补丁</li>
        <li>解压补丁文件（如为压缩包）</li>
        <li>将补丁文件放入游戏安装目录</li>
        <li>运行补丁程序或直接启动游戏</li>
        <li>检查游戏内文本是否已汉化</li>
      </ol>
      
      <h2>常见问题</h2>
      <h3>Q: 汉化后游戏无法启动？</h3>
      <p>A: 请确认补丁版本与游戏版本匹配，尝试以管理员权限运行游戏。</p>
      
      <h3>Q: 部分文本仍为日文？</h3>
      <p>A: 部分补丁可能未完全汉化所有文本，请检查补丁说明文档。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Computer%20screen%20showing%20visual%20novel%20game%20installation%20process%20with%20file%20folders%2C%20clean%20desktop%20setup%2C%20tutorial%20style%2C%20bright%20and%20clear%20visuals%2C%20modern%20anime%20aesthetic&width=800&height=600&seq=article-patch-guide&orientation=landscape',
    category: '教程指南',
    author: 'Galgame攻略组',
    date: '2024-04-20',
    tags: ['汉化补丁', '安装教程', '新手', '常见问题'],
    readCount: 67800,
  },
  {
    id: 5,
    title: '白色相簿2 深度剧评 — 为何被称为脱宅神作',
    slug: 'white-album-2-review',
    excerpt: '深度解析白色相簿2终章为何被无数玩家奉为恋爱游戏的巅峰，从角色塑造、剧情结构到音乐表现多维度评测这部传世之作。',
    content: `
      <h2>引言</h2>
      <p>「白色相簿2」终章被广大Galgame玩家称为"脱宅神作"——一部让人玩完后久久无法走出情感漩涡，甚至不想再接触其他恋爱游戏的作品。本文将从多个维度解析这部作品的独特魅力。</p>
      
      <h2>角色塑造的深度</h2>
      <p>小木曾雪菜与冬马和纱，两个女主角的形象塑造达到了Galgame史上罕见的深度。她们不是简单的"傲娇"或"温柔"标签，而是拥有完整人格、弱点与优点的真实人物。</p>
      
      <h2>剧情结构的精妙</h2>
      <p>IC（序章）→ CC（终章共通线）→ CODA（最终章）的三幕结构，让玩家的情感投入层层递进。</p>
      
      <h2>音乐的叙事力量</h2>
      <p>游戏中每一首音乐都与剧情紧密相连。《届かない恋》不仅是主题曲，更是整个故事的情感核心。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=White%20Album%202%20visual%20novel%20romantic%20winter%20scene%20with%20snow%20falling%20and%20piano%2C%20emotional%20melancholic%20atmosphere%2C%20soft%20lighting%2C%20beautiful%20anime%20art%20style%2C%20nostalgic%20mood&width=800&height=600&seq=article-wa2-review&orientation=landscape',
    category: '深度评测',
    author: 'Galgame评测组',
    date: '2024-05-08',
    tags: ['白色相簿2', '深度评测', '恋爱', '脱宅神作'],
    readCount: 41300,
  },
  {
    id: 6,
    title: 'Muv-Luv Alternative — 视觉小说史上评分最高的作品',
    slug: 'muv-luv-alternative-review',
    excerpt: 'Muv-Luv Alternative为何能在全球评分网站长期霸榜？从世界观构建到情感冲击力，全面解析这部传奇科幻视觉小说。',
    content: `
      <h2>前言</h2>
      <p>Muv-Luv Alternative在VNDB（全球最大的视觉小说数据库）中长期占据评分榜首。这部作品究竟有何魔力？</p>
      
      <h2>EX篇 → UNLIMITED篇 → ALTERNATIVE篇</h2>
      <p>从轻松的校园恋爱喜剧到残酷的异星战场，Muv-Luv的三部曲结构堪称游戏叙事的教科书。</p>
      
      <h2>战术机战斗的表现力</h2>
      <p>AGE社独创的视觉小说战斗演出系统，让战术机与BETA的战斗场面极具冲击力。</p>
      
      <h2>情感冲击的层层递进</h2>
      <p>Muv-Luv Alternative最令人称道的是其层层递进的情感冲击——从前两作的铺垫到最终的爆发。</p>
    `,
    coverImage: 'https://readdy.ai/api/search-image?query=Muv-Luv%20Alternative%20mecha%20battle%20scene%20with%20giant%20robots%20in%20epic%20sci-fi%20setting%2C%20dramatic%20lighting%2C%20military%20atmosphere%2C%20anime%20art%20style%2C%20cinematic%20composition&width=800&height=600&seq=article-muvluv-review&orientation=landscape',
    category: '深度评测',
    author: 'Galgame评测组',
    date: '2024-06-01',
    tags: ['Muv-Luv', '科幻', '机甲', '评分第一'],
    readCount: 35600,
  },
];

export function getArticleById(id: number) {
  return articles.find(a => a.id === id);
}

export function getRelatedArticles(currentId: number, count: number = 3) {
  return articles.filter(a => a.id !== currentId).slice(0, count);
}